import { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../core/auth/AuthContext";

const navItems = [
  { to: "/dashboard", label: "Operations" },
  { to: "/users", label: "Users & Support" },
  { to: "/friendships", label: "Network & Follows" },
  { to: "/wecommendations", label: "Wecommendations" },
  { to: "/collections", label: "Collections" },
  { to: "/shares", label: "Shares" }
];

export function AdminLayout() {
  const { email, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [isMobileLayout, setIsMobileLayout] = useState(
    typeof window !== "undefined" ? window.matchMedia("(max-width: 1100px)").matches : false
  );

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const mediaQuery = window.matchMedia("(max-width: 1100px)");
    const syncLayout = () => {
      setIsMobileLayout(mediaQuery.matches);
      if (!mediaQuery.matches) {
        setMobileNavOpen(false);
      }
    };

    syncLayout();

    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", syncLayout);
      return () => mediaQuery.removeEventListener("change", syncLayout);
    }

    mediaQuery.addListener(syncLayout);
    return () => mediaQuery.removeListener(syncLayout);
  }, []);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="layout">
      <aside className={`sidebar ${mobileNavOpen ? "open" : ""}`}>
        <div className="brand">
          we<span>commend</span> admin
        </div>
        <nav className="nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              onClick={() => setMobileNavOpen(false)}
              className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">Operations Console</div>
      </aside>

      <main className="main">
        <header className="page-header">
          <button type="button" className="sidebar-toggle tertiary" onClick={() => setMobileNavOpen((prev) => !prev)}>
            Menü
          </button>
          <div className="login-status">Eingeloggt ({email || "unknown"})</div>
          <button type="button" className="tertiary" onClick={handleLogout}>
            Logout
          </button>
        </header>
        <Outlet />
      </main>
      {mobileNavOpen && isMobileLayout ? (
        <button
          type="button"
          aria-label="Sidebar schließen"
          className="sidebar-backdrop"
          onClick={() => setMobileNavOpen(false)}
        />
      ) : null}
    </div>
  );
}
